import { PackageType } from '../packagesGrid/types';

export const NOT_EDITABLE_TYPES = [
  PackageType.SVA,
  PackageType.Sandbox,
  PackageType.Ghostr,
  PackageType.NSVA,
  PackageType.K8s,
];
